/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { makeCodecFamily } from "../../codec/index.js";
import { makeOptionalFieldCodec as makeV1Codec } from "./optionalFieldCodecV1.js";
import { makeOptionalFieldCodec as makeV2Codec } from "./optionalFieldCodecV2.js";
export const makeOptionalFieldCodecFamily = (revisionTagCodec) => makeCodecFamily([
    [1, makeV1Codec(revisionTagCodec)],
    [2, makeV2Codec(revisionTagCodec)],
]);
//# sourceMappingURL=optionalFieldCodecs.js.map